import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { CandidateType } from '../model/hros/recruiting';
import { AsyncStatus, AsyncStatusEnum } from '../model/common/AsyncStatus';
import api from '../utils/api';

export interface ProfileState {
  fetchStatus: AsyncStatus;
  saveStatus: AsyncStatus;
  fetchError?: string,
  saveError?: string,
  profile?: Profile;
}

const initialState: ProfileState = {
  fetchStatus: AsyncStatusEnum.IDLE,
  saveStatus: AsyncStatusEnum.IDLE,
  fetchError: undefined,
  saveError: undefined,
  profile: undefined
};

export interface Profile extends CandidateType {

}

export const fetchProfile = createAsyncThunk('profile/fetchProfile', () => {
  return api.get<Profile>(`api/v1/profile`);
});

export const saveProfile = createAsyncThunk('profile/saveProfile', (profile: CandidateType) => {
  return api.post<CandidateType>(`api/v1/profile`, {
    body: JSON.stringify(profile),
    headers: {
      "Content-Type": "application/json"
    }
  });
});

const profileSlice = createSlice({
    name: 'profile',
    initialState,
    reducers: {
    },
    extraReducers: {
      [fetchProfile.pending.toString()]: (state, action) => {
        state.fetchStatus = AsyncStatusEnum.LOADING;
      },
      [fetchProfile.fulfilled.toString()]: (state, action) => {
        state.fetchStatus = AsyncStatusEnum.SUCCEEDED;
        state.profile = action.payload;
      },
      [fetchProfile.rejected.toString()]: (state, action) => {
        state.fetchStatus = AsyncStatusEnum.FAILED;
        state.fetchError = action.error.message;
      },      
      [saveProfile.pending.toString()]: (state, action) => {
        state.saveStatus = AsyncStatusEnum.LOADING;
      },
      [saveProfile.fulfilled.toString()]: (state, action) => {
        state.saveStatus = AsyncStatusEnum.SUCCEEDED;
        state.profile = action.payload;
      },
      [saveProfile.rejected.toString()]: (state, action) => {
        state.saveStatus = AsyncStatusEnum.FAILED;
        state.saveError = action.error.message;
      }
    }
});

export default profileSlice;
